import { Injectable, InjectionToken } from '@angular/core';
import EstensaModel, { AuthenticationData, ImagingOpenParams, PacsStudyData as PacsStudyDataNg1 } from 'estensa-module';
import { noop } from 'lodash-es';
import { PacsStudyDataVnext } from './common';
import {
    ExaminationStatusForImaging,
    ModelKeyImage,
    ModelShowImage,
    ModelUSMeasureShow,
    ModelUSStressEchoAssociateImages,
    OpenImagesOptions,
} from './ebit-viewer-api';
import { DeepPartial } from '../../utils/types';

export const RADIOLOGY_API_CLIENT_IMAGING_SERVICE = new InjectionToken('radiology.api.client.imaging.service');


export interface MammographySettings {
    mammographicViewer: EstensaModel.MammographicViewerType;
    enableDedicatedWebViewerForMammography: boolean;
}


export interface IImagingServiceNg1 {
    areImagesOpen: boolean;

    discardImages(askConfirmation?: boolean): Promise<void>;

    openImages(
        imagingData: PacsStudyDataNg1[],
        credentials: AuthenticationData | null,
        options: Partial<ImagingOpenParams>,
    ): Promise<void>;

    setViewerHelper(helper: IViewerHelper): void;

    setGenericViewerHelper(helper: IViewerHelper): void;

    setCardioViewerHelper(helper: IViewerHelper): void;

    setRadioViewerHelper(helper: IViewerHelper): void;

    activateCardioViewer(): void;

    activateRadioViewer(): void;

    activateGenericViewer(): void;

    isVNext(): boolean;

    isViewerOpen(): boolean;

    closeViewer(): void;

    getViewerType(): string;

    getMammographySettings(): MammographySettings;
}

export interface IViewerHelper {
    readonly isVNext: boolean;
    readonly viewerType: string;

    discardImages(askConfirmation?: boolean): Promise<void>;

    init(): Promise<void>;

    openImages(imagingData: PacsStudyDataVnext[], options: DeepPartial<OpenImagesOptions>): Promise<void>;

    openViewer(): Promise<void>;

    closeViewer(): Promise<void>;

    setExaminationStatus?(
        idExaminations: string[],
        status: ExaminationStatusForImaging,
        studyInstanceUIDs: string[],
    ): Promise<void>;

    deleteKeyImage?(data: ModelKeyImage): Promise<void>;

    usStressEchoSelectStage?(stage: string): Promise<void>;

    usStressEchoSelectView?(view: string): Promise<void>;

    uSStressEchoAssociateImages?(model: ModelUSStressEchoAssociateImages): Promise<void>;

    showImage?(model: ModelShowImage): Promise<void>;

    usMeasureShow?(model: ModelUSMeasureShow): Promise<void>;

    // Compatibilità html5
    openImagesRequired(imagingData: PacsStudyDataNg1[], options?: DeepPartial<ImagingOpenParams>): void;

    discardImagesRequired(): void;

    closeViewerRequired(): void;

    isFormSubmitting(): boolean;

    isViewerOpen(): Promise<boolean>;

    areImagesOpen(): Promise<boolean>;
}

@Injectable()
export class NullImagingService implements IImagingServiceNg1 {
    areImagesOpen = false;
    discardImages = async () => {
        /* noop */
    };
    openImages = async () => {
        /* noop */
    };

    setViewerHelper = noop;

    setCardioViewerHelper = noop;

    setRadioViewerHelper = noop;

    activateCardioViewer = noop;
    activateRadioViewer = noop;
    activateGenericViewer = noop;
    setGenericViewerHelper = noop;
    closeViewer = noop;

    getViewerType = () => '';

    getMammographySettings = (): MammographySettings => ({
        mammographicViewer: EstensaModel.MammographicViewerType.None,
        enableDedicatedWebViewerForMammography: false,
    });

    isVNext(): boolean {
        return false;
    }

    isViewerOpen(): boolean {
        return false;
    }
}
